<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>  
    <el-form-item :label="$t('按钮对齐')">
        <el-radio-group v-model="data.align">
          <el-radio-button label="left">{{$t('左')}}</el-radio-button>
          <el-radio-button label="center">{{$t('中')}}</el-radio-button>
          <el-radio-button label="right">{{$t('右')}}</el-radio-button>
        </el-radio-group>
    </el-form-item>    
    <el-form-item :label="$t('是否可见')">
      <el-switch v-model="data.display"></el-switch>
    </el-form-item>
    <div v-for="(btn, index) in data.btns" :key="index" class="button-config-item">
      <el-card shadow="hover">
        <div slot="header" class="clearfix">
          <span>{{ $t('按钮') }} {{ index + 1 }}</span>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            icon="el-icon-circle-plus-outline"
            @click="handleAddButton()"
          ></el-button>
          <el-button
            style="float: right; padding: 3px 0"
            type="text"
            icon="el-icon-delete"
            @click="handleRemoveButton(index)"
          ></el-button>
        </div>        
        <el-form-item :label="$t('按钮类型')">
          <l-select v-model="btn.type" :options="typeOptions"></l-select>
        </el-form-item>
        <el-form-item :label="$t('按钮尺寸')">
          <el-radio-group v-model="btn.size">
            <el-radio-button label="medium">{{$t('中等')}}</el-radio-button>
            <el-radio-button label="small">{{$t('较小')}}</el-radio-button>
            <el-radio-button label="mini">{{$t('迷你')}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('按钮标题')">
          <el-input v-model="btn.label"></el-input>
        </el-form-item>         
        <el-form-item :label="$t('按钮图标')">
          <l-input-icon v-model="btn.icon"></l-input-icon>
        </el-form-item>   
        <el-form-item :label="$t('朴素按钮')">
          <el-switch v-model="btn.plain"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('圆角按钮')">
          <el-switch v-model="btn.round"></el-switch>
        </el-form-item>
        <el-form-item :label="$t('圆形按钮')">
          <el-switch v-model="btn.circle"></el-switch>
        </el-form-item>
        <l-code-editor-button 
                        :key="index"  
                        :btnText="$t('添加点击脚本')"
                        :theme="$t('eclipse')"
                        v-model="btn.executecode"
                        mode="application/javascript"
                        :Hints="handleHint()"
                        class="el-button el-button--text el-button--mini">
                        <span>点击脚本</span>                        
                    </l-code-editor-button>
      </el-card>
    </div>
  </div>  
</template>

<script>
export default {
  name: "config-btns",
  inject: ["formDesign"],
  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data() {
    return {
      typeOptions: [
        {value:'primary',label:'primary'},
        {value:'success',label:'success'},
        {value:'warning',label:'warning'},
        {value:'danger',label:'danger'},
        {value:'info',label:'info'},
        {value:'text',label:'text'},
      ]
    }
  },
  created() {
    // 确保 data 对象有必要的属性
    this.$set(this.data, 'align', this.data.align || 'left');
    this.$set(this.data, 'btns', this.data.btns || []);
    
    // 如果按钮数组为空，添加一个默认按钮
    if (this.data.btns.length === 0) {
      this.handleAddButton();
    }
  },
  methods: {
    handleHint(text) {
            text = text.replace(/'/g, '')
            text = text.replace(/"/g, '')
            const myList = this.formDesign.nowComponentList.filter(t => t.pprop == this.data.prop && (t.label.indexOf(text) != -1 || t.prop.indexOf(text) != -1))
            const list = this.formDesign.nowComponentList.filter(t => t.pprop != this.data.prop && (t.label.indexOf(text) != -1 || t.prop.indexOf(text) != -1))

            myList.push(...list)
            return this.$hints.all(myList)
        },
    handleAddButton() {
      // 使用 $set 确保响应性
      this.$set(this.data.btns, this.data.btns.length, {
        type: 'primary',
        size: 'mini',
        label: this.$t('按钮'),
        icon: '',
        plain: false,
        round: false,
        circle: false,
        code:`btn_${this.$uuid().replace(/-/g, '')}`,
        executecode: ''
      });
    },
    handleRemoveButton(index) {
      if(this.data.btns.length > 1){
        this.data.btns.splice(index, 1);
      }
    }
  }
}
</script>

<style scoped>
.button-config-item {
  margin-bottom: 20px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>